<script lang="ts">
  import { onMount } from "svelte";
  import { createEventDispatcher } from 'svelte'
  import Indicator from "./Indicator.svelte";
  import { ExerciseData } from "../dataTypes/exerciseData"
  import type { UserExerciseData } from "../stores/userExerciseDataStore";
  import { conceptDatasStore } from "../stores/conceptDatasStore"
  import type {ConceptData} from "../stores/conceptDatasStore"

  export let exerciseData:ExerciseData
  // svelte-ignore unused-export-let
  export let userExerciseData:UserExerciseData; userExerciseData;

  const dispatch = createEventDispatcher<{completed:void}>()
  let options:Array<{id:string, text:string, isWrong:boolean}> = new Array<{id:string, text:string, isWrong:boolean}>()
  let question:string
  let selectedOption:{id:string, text:string, isWrong:boolean}
  let isSuccess:boolean|null = null

  onMount(()=> {
    options.push(createOption(exerciseData.answerConceptID))
    for (const conceptID of exerciseData.optionConceptIDs) {
      options.push(createOption(conceptID))
    }
    options.sort(() => Math.random() - 0.5);
    options = options
    const conceptData:ConceptData = $conceptDatasStore.get(exerciseData.answerConceptID)
    question = exerciseData.question.replace(
        "$question",
        (conceptData as any)[exerciseData.questionField]
      );
  })

  function createOption(conceptID:string):{id:string, text:string, isWrong:boolean} {
     const conceptData:ConceptData = $conceptDatasStore.get(conceptID)
     return {
       id:conceptID,
       text:(conceptData as any)[exerciseData.answerField], 
       isWrong:false}
  }

  function handleInput(option:{id:string, text:string, isWrong:boolean}):void {
    selectedOption = option
  }

  function handleSubmit():void {
    if (selectedOption?.id == exerciseData.answerConceptID) {
      isSuccess = true
      dispatch('completed')
    }
    else {
      isSuccess = false
      if (selectedOption) {
        selectedOption.isWrong = true
      }
      options = options
    }
  }
</script>

<div class="flex flex-col items-center justify-center w-full h-full text-darkFore">
  <Indicator success={isSuccess}></Indicator>
  <fieldset>
    <legend>{@html question}</legend>
    {#each options as option}
        <div class="block">
          <input type="radio" id={option.id} on:input={()=>{handleInput(option)}} name="option" disabled={option.isWrong}/>
          <label for={option.id} class="cursor-pointer flex flex-row items-center">
            <span class="rounded-full w-4 h-4 flex items-center justify-center outline-solarized mr-1"></span>
            <div class:line-through={option.isWrong}>{option.text}</div>
            {#if option.isWrong || isSuccess}
            &nbsp;Concept:&nbsp;<var>{$conceptDatasStore.get(option.id).name}</var>
            {/if}
          </label>
        </div>
    {/each}
  </fieldset>
  <button on:click={handleSubmit} class="btn-darkBackHigh">Submit</button>
</div>

<style>
  label:hover {
    @apply bg-darkBackHigh;
    @apply text-darkForeHigh;
  }

  input[type="radio"] {
    @apply opacity-0;
  }

  input[type="radio"]:checked + label span {
    @apply bg-darkFore;
  }

</style>